const pageTitle = "识诗词"

export default function getPageTitle(title) {
    let lasttitle = '';
    if (!title) {
        lasttitle = pageTitle
    } else {
        lasttitle = title + '-' + pageTitle
    }
    return lasttitle
}
